export function setWebsiteTitle(title) {
    if (!title)
        return;
    else
        document.title = title;
}
